import React from 'react'
import { Chip } from '@material-ui/core'
import clsx from 'clsx'

import useStyles from './styles'
import constants from 'constants/index'

const ChipStatus = ({ status }) => {
  const classes = useStyles()
  const companySupplierConstants = constants.companySuppliers

  return (
    <Chip
      className={clsx(classes.root, {
        [classes.active]: status === companySupplierConstants.ACTIVE_STATUS,
        [classes.inactive]: status === companySupplierConstants.INACTIVE_STATUS,
      })}
      label={companySupplierConstants.STATUSES_LABEL[status]}
      size="small"
    />
  )
}

export default ChipStatus
